import GarbageCollectionIcon from './component'

export default GarbageCollectionIcon
